/**
 * The element that actually scrolls a page. Null means the window is the scroller.
 *
 * The shell marks its scrolling container with data-app-scroll-container, so ask for it
 * by name first, and only fall back to walking the ancestors, and only then to the
 * window. The walk is unreliable on its own: WebKit and Blink disagree about it, which
 * is how Safari once measured a scroll-driven section against the window and sized it
 * 128px too tall for the container it sat in.
 *
 * Resolve on every read, never once at mount: the shell is not above the element yet
 * when an effect first runs, so a cached answer is "the window" forever.
 *
 * Anything listening for scroll should listen on the DOCUMENT IN THE CAPTURE PHASE:
 * scroll events do not bubble, so a window listener hears nothing when a container is
 * doing the scrolling, but capture hears the event whichever element produced it.
 */
export function findScroller(from: HTMLElement): HTMLElement | null {
  const marked = document.querySelector<HTMLElement>("[data-app-scroll-container]");
  if (marked && marked.contains(from)) return marked;
  let el: HTMLElement | null = from.parentElement;
  while (el && el !== document.body && el !== document.documentElement) {
    const overflow = getComputedStyle(el).overflowY;
    if (overflow === "auto" || overflow === "scroll") return el;
    el = el.parentElement;
  }
  return null;
}
